import {
  IconEdit,
  IconMailShare,
  IconThumbDown,
  IconThumbUp,
} from '@tabler/icons-react';
import { PizzaTrackerStep } from 'types/pizzaGraph';
import { ChipColor } from 'ui-component/extended/Chip';

export enum CommonStatusSteps {
  APPROVED = 'approved',
  SENT = 'sent',
  VOIDED = 'voided',
  DRAFT = 'draft',
}

export const commonStatusStepDefaults: {
  [key in CommonStatusSteps]: PizzaTrackerStep;
} = {
  [CommonStatusSteps.APPROVED]: {
    key: CommonStatusSteps.APPROVED,
    label: 'Approved',
    icon: IconThumbUp,
    infoDescriptionComplete: 'This record has been approved.',
    infoDescriptionIncomplete: 'This record has not been approved.',
  },
  [CommonStatusSteps.SENT]: {
    key: CommonStatusSteps.SENT,
    label: 'Sent',
    icon: IconMailShare,
    infoDescriptionComplete: 'This record has been sent.',
    infoDescriptionIncomplete: 'This record has not been sent.',
  },
  [CommonStatusSteps.VOIDED]: {
    key: CommonStatusSteps.VOIDED,
    label: 'Rejected',
    icon: IconThumbDown,
    color: ChipColor.error,
    infoDescriptionComplete: 'This record has been rejected.',
    infoDescriptionIncomplete: 'This record has not been rejected.',
  },
  [CommonStatusSteps.DRAFT]: {
    key: CommonStatusSteps.DRAFT,
    label: 'Draft',
    icon: IconEdit,
    color: ChipColor.grey,
  },
};
